import Card, { CARD_SIZE, CARD_TYPE } from './Card';

export default Card;
export { CARD_SIZE, CARD_TYPE };
